/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { OrganizationBaseService } from '../organization-base-service';
import { OrganizationApiConfiguration } from '../organization-api-configuration';
import { OrganizationStrictHttpResponse } from '../organization-strict-http-response';

import { consumerHealthcareServicePost } from '../fn/consumer/consumer-healthcare-service-post';
import { ConsumerHealthcareServicePost$Params } from '../fn/consumer/consumer-healthcare-service-post';
import { consumerOnboardingOrganizationTemplatesGet } from '../fn/consumer/consumer-onboarding-organization-templates-get';
import { ConsumerOnboardingOrganizationTemplatesGet$Params } from '../fn/consumer/consumer-onboarding-organization-templates-get';
import { consumerOrganizationListGet } from '../fn/consumer/consumer-organization-list-get';
import { ConsumerOrganizationListGet$Params } from '../fn/consumer/consumer-organization-list-get';
import { consumerOrganizationsPageSizeGet } from '../fn/consumer/consumer-organizations-page-size-get';
import { ConsumerOrganizationsPageSizeGet$Params } from '../fn/consumer/consumer-organizations-page-size-get';
import { HealthcareServiceConsumerModel } from '../models/healthcare-service-consumer-model';
import { OnboardingOrganizationTemplateModel } from '../models/onboarding-organization-template-model';
import { OrganizationListResponseModel } from '../models/organization-list-response-model';
import { OrganizationSearchResultModel } from '../models/organization-search-result-model';

@Injectable({ providedIn: 'root' })
export class ORGConsumerService extends OrganizationBaseService {
  constructor(config: OrganizationApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `consumerHealthcareServicePost()` */
  static readonly ConsumerHealthcareServicePostPath = '/Consumer/HealthcareService';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerHealthcareServicePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  consumerHealthcareServicePost$Response(params?: ConsumerHealthcareServicePost$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<Array<HealthcareServiceConsumerModel>>> {
    return consumerHealthcareServicePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerHealthcareServicePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  consumerHealthcareServicePost(params?: ConsumerHealthcareServicePost$Params, context?: HttpContext): Observable<Array<HealthcareServiceConsumerModel>> {
    return this.consumerHealthcareServicePost$Response(params, context).pipe(
      map((r: OrganizationStrictHttpResponse<Array<HealthcareServiceConsumerModel>>): Array<HealthcareServiceConsumerModel> => r.body)
    );
  }

  /** Path part for operation `consumerOrganizationsPageSizeGet()` */
  static readonly ConsumerOrganizationsPageSizeGetPath = '/Consumer/Organizations/{pageSize}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerOrganizationsPageSizeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerOrganizationsPageSizeGet$Response(params: ConsumerOrganizationsPageSizeGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<Array<OrganizationSearchResultModel>>> {
    return consumerOrganizationsPageSizeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerOrganizationsPageSizeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerOrganizationsPageSizeGet(params: ConsumerOrganizationsPageSizeGet$Params, context?: HttpContext): Observable<Array<OrganizationSearchResultModel>> {
    return this.consumerOrganizationsPageSizeGet$Response(params, context).pipe(
      map((r: OrganizationStrictHttpResponse<Array<OrganizationSearchResultModel>>): Array<OrganizationSearchResultModel> => r.body)
    );
  }

  /** Path part for operation `consumerOrganizationListGet()` */
  static readonly ConsumerOrganizationListGetPath = '/Consumer/OrganizationList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerOrganizationListGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerOrganizationListGet$Response(params?: ConsumerOrganizationListGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<Array<OrganizationListResponseModel>>> {
    return consumerOrganizationListGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerOrganizationListGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerOrganizationListGet(params?: ConsumerOrganizationListGet$Params, context?: HttpContext): Observable<Array<OrganizationListResponseModel>> {
    return this.consumerOrganizationListGet$Response(params, context).pipe(
      map((r: OrganizationStrictHttpResponse<Array<OrganizationListResponseModel>>): Array<OrganizationListResponseModel> => r.body)
    );
  }

  /** Path part for operation `consumerOnboardingOrganizationTemplatesGet()` */
  static readonly ConsumerOnboardingOrganizationTemplatesGetPath = '/Consumer/OnboardingOrganizationTemplates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerOnboardingOrganizationTemplatesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerOnboardingOrganizationTemplatesGet$Response(params?: ConsumerOnboardingOrganizationTemplatesGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<Array<OnboardingOrganizationTemplateModel>>> {
    return consumerOnboardingOrganizationTemplatesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerOnboardingOrganizationTemplatesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerOnboardingOrganizationTemplatesGet(params?: ConsumerOnboardingOrganizationTemplatesGet$Params, context?: HttpContext): Observable<Array<OnboardingOrganizationTemplateModel>> {
    return this.consumerOnboardingOrganizationTemplatesGet$Response(params, context).pipe(
      map((r: OrganizationStrictHttpResponse<Array<OnboardingOrganizationTemplateModel>>): Array<OnboardingOrganizationTemplateModel> => r.body)
    );
  }

}
